import { Injectable } from '@angular/core';
import {
     ActivatedRouteSnapshot,
     CanActivate,
     CanActivateChild,
     Router,
     RouterStateSnapshot,
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from '../services/data.service';
import { WsService } from '../services/ws/ws.service';
import { CrashMessageService } from '../services/crash-message.service';

@Injectable()
export class DataBootstrapGuard implements CanActivateChild, CanActivate {
     idCenter = window.app.club.id;

     constructor(
          private router: Router,
          private loader: NgxSpinnerService,
          private data: DataService,
          private ws: WsService,
          private crash: CrashMessageService
     ) {}

     async canActivate(
          next: ActivatedRouteSnapshot,
          state: RouterStateSnapshot
     ): Promise<boolean> {
          if (!this.data.didInitLoad) {
               try {
                    let xhrRes: any;
                    xhrRes = await this.ws.planning.taskList({
                         idCenter: this.idCenter,
                    });
                    this.data.tasks$ = xhrRes;
                    xhrRes = await this.ws.planning.coachesList({
                         idCenter: this.idCenter,
                    });
                    this.data.coaches$ = xhrRes;
                    xhrRes = await this.ws.planning.groupList({
                         idCenter: this.idCenter,
                         onlyActive: true,
                    });
                    this.data.groups$ = xhrRes;
                    xhrRes = await this.ws.planning.userBookingList();
                    this.data.userBooking$ = xhrRes;
                    this.data.didInitLoad = true;
                    return true;
               } catch (err) {
                    this.crash.setMessage(`
          ${(err && err.error && err.error.ctxCode) || '-'}
          \n\n
          ${err.message}
        `);
                    this.router.navigateByUrl('/crash');
                    return false;
               }
          } else {
               return true;
          }
     }

     canActivateChild(
          next: ActivatedRouteSnapshot,
          state: RouterStateSnapshot
     ): Promise<boolean> {
          return this.canActivate(next, state);
     }
}
